/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Tags_Manager_Error_Create_Set_ToastInputs */



/**
* | output |
* | --- |
* | "Error creating new set: {error}" |
*
* @param {Tags_Manager_Error_Create_Set_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_error_create_set_toast = /** @type {((inputs: Tags_Manager_Error_Create_Set_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Error_Create_Set_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Erreur lors de la creation de l'ensemble : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehler beim Erstellen des neuen Sets: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Errore durante la creazione del nuovo set: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Ошибка при создании нового набора: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al crear nuevo conjunto: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`创建新数据集时出错：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`新しいセットの作成中にエラーが発生しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`नया सेट बनाने में त्रुटि: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Erro ao criar novo conjunto: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Error creating new set: ${i?.error}`)
});